import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { LogOut } from 'src/app/store/authentication/auth.action';
import { NumberProduct } from 'src/app/store/reservation/reservation.action';
import { ChangeMenuActive } from 'src/app/store/menu/menu.action';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  store_id: any;

  constructor(
    private messageService: MessageService,
    private router: Router,
    private store: Store<AppState>,
    private route: ActivatedRoute,

  ) {
  }

  protected apiUrl: string = environment.apiUrl;
  API_IGNORE_HANDLE_ERROR = [this.apiUrl + 'oauth/token'];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.API_IGNORE_HANDLE_ERROR.includes(req.url)) {
      return next.handle(req);
    } else {
      return next.handle(req)
        .pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              if (event.body && event.body.code < -1000) {
                this.store_id = localStorage.getItem('store_id');
                this.store.dispatch(new LogOut());
                this.router.navigate([`${this.store_id}/`]);
              }
            }
            return event;
          })
          ,
          catchError((error: any) => {  // then handle the error
            return this.handleError(error);
          }));
    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,

      console.log(error);
      this.messageService.add({ severity: 'error', summary: error.statusText, detail: error.message });
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }
}
